// @ts-nocheck
import { createSlice } from '@reduxjs/toolkit';

import { UpsellState } from '@greenkub-fronts/shared/interface';

import { initUpsellPage } from './useCases/init-upsell-page/init-upsell-page.use-case';
import { onChangeStudio } from './useCases/on-change-studio/on-change-studio';

export const UPSELL_FEATURE_KEY = 'upsell';

const initialUpsellStateInit = (): UpsellState => {
  return {
    project: undefined,
    configurationsPack: [],
  };
};

export const initialUpsellState: UpsellState = initialUpsellStateInit();

const backUpsellsiteSlice = createSlice({
  name: UPSELL_FEATURE_KEY,
  initialState: initialUpsellState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(initUpsellPage.fulfilled, (state, action) => {
      state.project = action.payload.project;
      state.configurationsPack = action.payload.configurationsPack;
    });
    builder.addCase(onChangeStudio.fulfilled, (state, action) => {
      state.configurationsPack = action.payload?.configurationsPack;
    });
  },
});

export const upsell = backUpsellsiteSlice.reducer;

export const upsellActions = backUpsellsiteSlice.actions;
